module.exports = __webpack_public_path__ + "img/hamamatsu.d2b568a4.jpg";